import type { ConnectorType, Port, SignalType } from '../model/schema.js';

/** Builds a port; `phantom` is only set when given so entries stay minimal. */
export function port(
  id: string,
  name: string,
  direction: Port['direction'],
  signal: SignalType,
  connector?: ConnectorType,
  phantom?: boolean,
): Port {
  const p: Port = { id, name, direction, signal };
  if (connector !== undefined) p.connector = connector;
  if (phantom !== undefined) p.phantom = phantom;
  return p;
}

/** `count` numbered ports `<prefix>1..<prefix>count` named `<label> 1..n`. */
export function numberedPorts(
  count: number,
  prefix: string,
  label: string,
  direction: Port['direction'],
  signal: SignalType,
  connector: ConnectorType,
  phantom?: boolean,
): Port[] {
  return Array.from({ length: count }, (_, i) =>
    port(`${prefix}${i + 1}`, `${label} ${i + 1}`, direction, signal, connector, phantom),
  );
}

/** Mains inlet port. */
export function powerIn(connector: ConnectorType, name = 'Power'): Port {
  return port('power', name, 'in', 'power', connector);
}
